export default __webpack_public_path__ + "static/school-720-dc6ea9038f8379f70d851f71e839daa2.mp4";